import React, { Component } from "react";


class PopupView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requestClose: false
    };

    this.requestClose = this.requestClose.bind(this);
  }

  componentWillReceiveProps(nextProps) {

  }

  requestClose() {
    console.log("requestClose");
    this.setState({requestClose: true}, () => this.props.onClose());
  }

  render() {
    const key = this.props.gameId + (this.props.gameBase === "tutor" ? "b":"");
    const gameName = this.props.t("menu3item" + key).replace(/(<br>)*/g,"");
    const {col, bcol} = this.props.item;
    const s ={ "color": col || "#fff", "backgroundColor": bcol || "#000"};

    return (
      <div className="popup">
        <div className="popup-close" onClick={this.requestClose}/>
        <div className={"popup-header-" + this.props.gameBase}><div className={"idGame_"+ this.props.gameBase} style={s}>{this.props.gameId}</div><div className="popup-title" dangerouslySetInnerHTML={{__html: gameName}}></div></div>
        <div className="popup-inner-content">
          <div className="popup-content" dangerouslySetInnerHTML={{__html: this.props.t("menu3game"+ key) || this.props.t("nodescription")}}></div>
          <div className="popup-cartridge"><img src={"/htmldata/images/games/cartridges/cartridge"+key+".jpg"}  alt="cartridge"></img></div>
        </div>
        <div className="popup-footer"></div>
      </div>
    );
  }
}


export default PopupView;
